import { render, staticRenderFns } from "./cardPointData.vue?vue&type=template&id=4e13c8ee&scoped=true"
import script from "./cardPointData.vue?vue&type=script&lang=js"
export * from "./cardPointData.vue?vue&type=script&lang=js"
import style0 from "./cardPointData.vue?vue&type=style&index=0&id=4e13c8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13c8ee",
  null
  
)

export default component.exports